export default "__VITE_ASSET__D4367k9i__"